import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import Navbar from "../Navbar";
import { SEO } from "../SEO";

function PrivacyPolicy() {
  const [activeTab, setActiveTab] = React.useState<"terms" | "privacy">(
    "privacy",
  );
  const navigate = useNavigate();
  return (
    <>
      <SEO
        title="Privacy Policy | Afripay"
        description="Privacy Policy on Afripay."
        canonical="https://goafripay.com/privacy-policy"
      />
      <Navbar />
      <div className="pt-16">
        <div className="bg-[#001E0E] lg:px-14 px-6 md:pb-10 pb-10 mx-auto  flex flex-col lg:justify-center lg:space-x-14">
          <div className="place-self-center text-center md:pt-16 pt-8">
            <h1 className="md:text-5xl text-2xl text-[#fff] font-bold">
              Privacy Policy
            </h1>

            <p className="md:mt-2 mt-2 md:text-base text-[#fff] text-sm">
              Last Update : 25-8-2025
            </p>

            {/* Tab Navigation */}
            <div className="flex justify-center items-center bg-[#0B7F47] pt-2 space-x-8 mt-10 rounded-[5px]">
              <button
                onClick={() => navigate("/terms-of-use")}
                className="text-white text-lg font-[400] pb-2 transition-all duration-300 opacity-70 hover:opacity-90"
              >
                Terms of Service
              </button>
              <button
                onClick={() => navigate("/privacy-policy")}
                className="text-white text-lg font-[400] pb-2 transition-all duration-300 border-b-2 border-white opacity-100"
              >
                Privacy Policy
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:px-20 px-6 pt-10 pb-5">
        {/* Privacy Policy */}
        <div>
          <p className="text-[#475467] text-[16px] font-[300]">
            Welcome to AfriPay, a service provided by AFRIPRO PLATFORM NIGERIA
            LTD. Your privacy is critically important to us. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you use our website (https://goafripay.com/),
            mobile applications, and related services (collectively, the
            “Services”).
          </p>
          <p className="text-[#475467] text-[16px] font-[300]">
            We are committed to protecting your personal data and respecting
            your privacy in compliance with global best practices, such as the
            Nigerian Data Protection Regulation (NDPR), the General Data
            Protection Regulation (GDPR), and other applicable laws.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Who We Are</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay is a cross-border financial platform dedicated to
            facilitating tuition payments, virtual accounts, savings, loans, and
            remittance services tailored for African students, freelancers, and
            remote workers. Our services are designed to empower Africans with
            seamless access to financial tools that enable international
            transactions, payments, and financial management.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Information We Collect
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We collect different types of information to provide and improve our
            Services. This includes:
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Personal Identifiable Information (PII)
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Date of birth</li>
            <li>Residential address</li>
            <li>
              National Identification Number (NIN), passport number, or other
              government-issued IDs
            </li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Financial Information
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Bank account details</li>
            <li>
              Card information (tokenized and stored via PCI-compliant
              third-party providers)
            </li>
            <li>Transaction history</li>
            <li>Virtual wallet balances</li>
            <li>Loan applications and repayment records</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Device and Technical Data
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li> IP address</li>
            <li>Device ID and type</li>
            <li>Browser type</li>
            <li>Operating system</li>
            <li>Geolocation data (if enabled)</li>
            <li>App crash logs and usage patterns</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Other Information
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>KYC verification data (e.g., selfies, scanned IDs)</li>
            <li>Communication history (with support or via feedback forms)</li>
            <li>Preferences and usage behavior</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Face Data and Biometric Information
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Our usage of face data within the Afripay app is currently limited
            to on-device facial detection solely for authentication and to
            secure certain key features. We do not collect, store, retain, or
            create faceprints or biometric identifiers.
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>
              <strong>Collection:</strong> Face data is processed on your device
              only and is not transmitted to our servers or third parties.
            </li>
            <li>
              <strong>Retention:</strong> Face data is not retained. Processing
              occurs in volatile memory during active use and is discarded
              immediately after the feature completes.
            </li>
            <li>
              <strong>Use:</strong> Face data is used exclusively to provide the
              feature in real time and is not used for analytics, profiling,
              advertising, or tracking.
            </li>
            <li>
              <strong>Sharing:</strong> We do not share face data with any third
              parties. No third parties store face data on our behalf.
            </li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Because we do not collect or store face data, there is no retention
            period and no third‑party storage.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            How We Use Your Information
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We use the information collected to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Provide, manage, and maintain your AfriPay account</li>
            <li>Facilitate cross-border and domestic payments</li>
            <li>Process and approve loan applications</li>
            <li>Provide virtual and physical cards</li>
            <li>Offer savings and investment tools</li>
            <li>Send notifications and confirmations (via SMS, email, push)</li>
            <li>Conduct identity verification and fraud prevention</li>
            <li>Comply with legal and regulatory obligations</li>
            <li>Improve user experience and platform functionality</li>
            <li>
              Offer travel, insurance, utility bill, and migration services
            </li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Legal Bases for Processing
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We process your data based on the following legal grounds:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>
              Consent: When you opt-in to use specific services (e.g.,
              newsletter, promotions)
            </li>
            <li>
              Contractual Obligation: To fulfill our service agreement with you
              (e.g., processing payments)
            </li>
            <li>
              Legal Obligation: For KYC, AML, tax compliance, and other
              regulatory requirements
            </li>
            <li>
              Legitimate Interest: To improve platform functionality, combat
              fraud, and perform analytics
            </li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Service Providers
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Payment processors (e.g., Fincra, Korapay)</li>
            <li>Cloud hosting providers</li>
            <li>KYC/identity verification vendors</li>
            <li>Customer support tools (e.g., CRM)</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Third-Party Integrations
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Travel booking platforms</li>
            <li>Insurance providers</li>
            <li>Bill payment and utility platforms</li>
            <li>Loan service partners</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Regulatory and Legal Entities
          </h3>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>
              Law enforcement and financial authorities when legally required
            </li>
            <li>Auditors and compliance consultants</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Cross-Border Data Transfers
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Because our services operate globally, your data may be transferred
            and stored in countries outside your own. We ensure that all
            international transfers are compliant with data protection laws and
            safeguarded by:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Standard Contractual Clauses (SCCs)</li>
            <li>Data Protection Agreements (DPAs)</li>
            <li>Secure cloud storage providers</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Data Retention
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We retain your information for as long as necessary to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Provide you with our services</li>
            <li>Fulfill legal, regulatory, and contractual obligations</li>
            <li>Resolve disputes and enforce our policies</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Typically, financial records are kept for a minimum of five (5)
            years as per industry compliance standards.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Security of Your Information
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We use a multi-layered security approach, including:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>AES-256 encryption for data at rest</li>
            <li>SSL/TLS encryption for data in transit</li>
            <li>JWT-based authentication and OAuth 2.0 protocols</li>
            <li>Two-Factor Authentication (2FA)</li>
            <li>Role-Based Access Control (RBAC)</li>
            <li>Real-time fraud detection systems</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Despite our efforts, no system is 100% secure. We advise users to
            use strong passwords and never share login credentials.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Your Rights and Choices
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Depending on your location, you may have the right to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Access the personal data we hold about you</li>
            <li>Correct inaccuracies in your data</li>
            <li>Request deletion or restriction of your data</li>
            <li>Object to processing based on legitimate interest</li>
            <li>Withdraw consent at any time</li>
            <li>Port your data to another service provider</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            To exercise these rights, please email:
            technicalsupport@goafripay.com
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Children’s Privacy
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AfriPay services are not intended for individuals under the age of
            18. We do not knowingly collect personal information from minors. If
            you believe that a minor has provided us with their data, please
            contact us for removal.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Cookies and Tracking Technologies
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We use cookies and similar technologies to:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Maintain sessions and logins</li>
            <li>Analyze usage and improve our services</li>
            <li>Personalize content and marketing</li>
          </ul>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            You can manage your cookie preferences through your browser
            settings. Disabling cookies may affect your experience on the
            platform.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Third-Party Links
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            Our platform may contain links to third-party websites. This Privacy
            Policy applies solely to information collected by AfriPay. We are
            not responsible for the privacy practices of third parties. Please
            review their privacy policies separately.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Data Breach Protocol
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            In the event of a data breach:
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Affected users will be notified within 72 hours.</li>
            <li>We will report the breach to relevant authorities.</li>
            <li>
              We will take remedial actions to secure compromised systems.
            </li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Changes to This Policy
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with a revised "Effective Date." If we
            make material changes, we will notify you via email or app
            notification.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">Contact Us</h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            For questions or concerns regarding this Privacy Policy, contact us
            at:
          </p>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            AFRIPRO PLATFORM NIGERIA LTD
          </p>
          <ul className="mt-2 list-disc list-outside text-[#475467] text-[16px] font-[300] pl-4">
            <li>Support Email: technicalsupport@goafripay.com</li>
            <li>Support Phone: +234 906 178 1999</li>
            <li>Website: https://goafripay.com</li>
          </ul>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Jurisdiction and Governing Law
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            This Privacy Policy shall be governed and construed in accordance
            with the laws of the Federal Republic of Nigeria. Any disputes
            arising out of this policy shall be subject to the exclusive
            jurisdiction of Nigerian courts.
          </p>
        </div>
        <div className="mt-5">
          <h3 className="text-[18px] font-[500] text-[#030319]">
            Acceptance of This Policy
          </h3>
          <p className="text-[#475467] text-[16px] font-[300] mt-1">
            By accessing or using our Services, you acknowledge that you have
            read, understood, and agreed to the terms of this Privacy Policy. If
            you do not agree, please discontinue use of our platform.
          </p>
        </div>

        {/* Privacy Policy - formal content */}

        {/* <div>
                    <div>

                        <h1 className='text-[36px] font-bold'>Privacy Policy</h1>

                        <h3 className='text-[20px] mt-2 text-[#6E7093]'>Last Updated: April 1, 2024</h3>
                    </div>
                    <p className='text-[16px] mt-3'>AfriPay is committed to protecting the privacy of our users. This Privacy Policy outlines how we collect, use, disclose, and safeguard your personal information when you use our services.</p>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Information We Collect</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>Personal Information: We may collect personal information such as your name, email address, phone number, and billing information when you register an account or make transactions through our platform.</li>
                            <li>Usage Information: We automatically collect information about your interactions with our platform, including your IP address, device information, and browsing activities.</li>
                            <li>Cookies: We use cookies and similar tracking technologies to enhance your experience and analyze usage patterns on our platform.</li>
                        </ul>
                    </div>

                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>How We Use Your Information</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>Provide Services: We use your information to deliver the services you request, such as processing transactions and managing your account.</li>
                            <li>Improve Our Platform: We analyze usage data to enhance and optimize our platform's performance and user experience.</li>
                            <li>Communicate with You: We may send you updates, promotional offers, and important notifications related to your account or our services.</li>
                            <li>Legal Compliance: We may use your information to comply with legal obligations or enforce our terms and policies.</li>
                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Information Sharing</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>Third-Party Service Providers: We may share your information with trusted third-party service providers to facilitate transactions and improve our services.</li>
                            <li>Legal Requirements: We may disclose your information in response to legal requests or to protect our rights, property, or safety, or that of others.</li>
                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Data Security</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>We implement appropriate security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction.</li>
                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Your Choices</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>You can update your account settings and preferences to manage communication preferences and opt-out of promotional emails.</li>
                            <li>You may also disable cookies in your browser settings, although this may affect your experience on our platform.</li>
                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Changes to this Policy</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>We reserve the right to update or modify this Privacy Policy at any time. We will notify you of any changes by posting the revised policy on our website.</li>
                        </ul>
                    </div>
                    <div className='mt-5'>
                        <h3 className='text-[25px] font-semibold'>Contact Us</h3>
                        <ul className='mt-2 list-disc list-outside space-y-2 text-black text-[16px] pl-4'>
                            <li>If you have any questions or concerns about our Privacy Policy, please contact us at <span className='text-[#209D5A]'>hello@goafripay.com</span>.</li>

                        </ul>
                    </div>
                </div> */}
      </div>

      <Footer />
    </>
  );
}

export default PrivacyPolicy;
